import { Navigate, Route, Routes } from 'react-router-dom'

import { Layout } from '@/components/Layout'
import { Spinner } from '@/components/ui'
import { useAuth } from '@/lib/auth'
import { ContactDetailPage } from '@/pages/ContactDetail'
import { ContactsPage } from '@/pages/Contacts'
import { ConversationDetailPage } from '@/pages/ConversationDetail'
import { ConversationsPage } from '@/pages/Conversations'
import { DangerPage } from '@/pages/Danger'
import { DashboardPage } from '@/pages/Dashboard'
import { IntroductionsPage } from '@/pages/Introductions'
import { LoginPage } from '@/pages/Login'
import { LogsPage } from '@/pages/Logs'
import { MatchDetailPage } from '@/pages/MatchDetail'
import { NetworkPage } from '@/pages/Network'
import { OpportunitiesPage } from '@/pages/Opportunities'

export function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner label="Starting LeadConnector" />
      </div>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="opportunities" element={<OpportunitiesPage />} />
        <Route path="opportunities/:matchId" element={<MatchDetailPage />} />
        <Route path="introductions" element={<IntroductionsPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="contacts/:contactId" element={<ContactDetailPage />} />
        <Route path="conversations" element={<ConversationsPage />} />
        <Route path="conversations/:conversationId" element={<ConversationDetailPage />} />
        <Route path="network" element={<NetworkPage />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="danger" element={<DangerPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
